var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2388_5150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H14C19.5228 0 24 4.47715 24 10V14C24 19.5228 19.5228 24 14 24H10C4.47715 24 0 19.5228 0 14V10Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2388_5150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1889 15.5C17.0912 15.402 17.0423 15.2941 17.0423 15.1765C17.0423 15.0588 17.0912 14.951 17.1889 14.8529L19.5635 12.4412H9.56678C9.42997 12.4412 9.32248 12.3971 9.2443 12.3088C9.16612 12.2206 9.12704 12.1176 9.12704 12C9.12704 11.8627 9.16612 11.7549 9.2443 11.6765C9.32248 11.598 9.42997 11.5588 9.56678 11.5588H19.5342L17.1303 9.11765C17.0521 9.03922 17.013 8.94118 17.013 8.82353C17.013 8.70588 17.0619 8.59804 17.1596 8.5C17.2573 8.40196 17.3697 8.35294 17.4967 8.35294C17.6238 8.35294 17.7264 8.41177 17.8046 8.52941L20.7362 11.4412C20.8143 11.5196 20.8779 11.6078 20.9267 11.7059C20.9756 11.8039 21 11.9118 21 12.0294C21 12.1275 20.9756 12.2206 20.9267 12.3088C20.8779 12.3971 20.8143 12.4902 20.7362 12.5882L17.8046 15.5294C17.7264 15.6078 17.6287 15.6471 17.5114 15.6471C17.3941 15.6471 17.2866 15.598 17.1889 15.5ZM4.61238 22C4.16287 22 3.78176 21.8431 3.46906 21.5294C3.15635 21.2157 3 20.8333 3 20.3824V3.61765C3 3.16667 3.15635 2.78431 3.46906 2.47059C3.78176 2.15686 4.16287 2 4.61238 2H11.8241C11.9609 2 12.0733 2.04412 12.1612 2.13235C12.2492 2.22059 12.2932 2.33333 12.2932 2.47059C12.2932 2.58824 12.2492 2.69118 12.1612 2.77941C12.0733 2.86765 11.9609 2.91176 11.8241 2.91176H4.61238C4.43648 2.91176 4.27036 2.98529 4.11401 3.13235C3.95766 3.27941 3.87948 3.44118 3.87948 3.61765V20.3824C3.87948 20.5588 3.95766 20.7206 4.11401 20.8676C4.27036 21.0147 4.43648 21.0882 4.61238 21.0882H11.8241C11.9609 21.0882 12.0733 21.1324 12.1612 21.2206C12.2492 21.3088 12.2932 21.4216 12.2932 21.5588C12.2932 21.6765 12.2492 21.7794 12.1612 21.8676C12.0733 21.9559 11.9609 22 11.8241 22H4.61238Z",
    fill: "#D70F57"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSair);
export default __webpack_public_path__ + "static/media/sair.d4aaeaa726097b605bcfc2196dc528ec.svg";
export { ForwardRef as ReactComponent };